<template>
  <ValidationProvider v-slot="{ errors, valid }" :name="label" :rules="rules">
    <BaseField
      :label-for="$attrs.id"
      :label="label"
      :type="{ 'is-danger': errors[0], '': valid }"
      :message="errors"
    >
      <b-datepicker
        v-model="currentValue"
        :locale="getLocale()"
        :show-week-number="false"
        icon="calendar-today"
        editable
        append-to-body
        v-bind="$attrs"
        size="is-small"
        custom-class="f-input"
      ></b-datepicker>
    </BaseField>
  </ValidationProvider>
</template>

<script>
import BaseFieldMixin from './BaseFieldMixin'
import BaseField from './BaseField'

export default {
  components: {
    BaseField,
  },
  mixins: [BaseFieldMixin],
  inheritAttrs: false,
  methods: {
    getLocale() {
      return this.$i18n.locale === 'en' ? 'en-US' : 'es-ES'
    },
  },
}
</script>
